<template>
<div>
    <pt-sub-title title="用户信息"></pt-sub-title>
    <table :class="$style['customer-message-old-to-new']">
      <pt-message-table-item label="生命银行用户" >{{BringNewAuditDetail.userName}}</pt-message-table-item>
      <pt-message-table-item label="C端手机号">{{BringNewAuditDetail.userMobile}}</pt-message-table-item>
        <pt-message-table-item label="用户类型">{{customer_type}}</pt-message-table-item>
        <pt-message-table-item label="CPS合同号">{{BringNewAuditDetail.cpsContractCode}}</pt-message-table-item>
        <pt-message-table-item label="发放时间">{{BringNewAuditDetail.reward_date}}</pt-message-table-item>
        <pt-message-table-item label="发放人">{{BringNewAuditDetail.operatorName}}</pt-message-table-item>
    </table>
    <pt-sub-title :title="customerTitle"></pt-sub-title>
    <div :class="$style['reject-message']">
    <customer-message @formValue="formValue" :customer="BringNewAuditDetail" :isEditCoupons="true" isReject ref="customerMessage"></customer-message>
    </div>
    <div class="button-div">
        <el-button type="primary" @click="submitReview" :loading="submitLoading">提交审核</el-button>
        <!-- <el-button type="primary" plain @click="cancel">取消</el-button> -->
    </div>
</div>
</template>
<script>

import customerMessage from './customer-message'
import { cashCount } from '@/utils/formUtils'
export default {
  components: {
    customerMessage
  },
  props: {
    BringNewAuditDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    customerType: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    }
  },
  computed: {
    // 用户奖励修改标题
    customerTitle () {
      return this.customerType === 'OLD' ? '老用户奖励' : '新用户奖励'
    },
    customer_type () {
      return this.customerType === 'OLD' ? '老用户' : '新用户'
    },
    form () {
      return this.$refs.customerMessage
    }
  },
  data () {
    return {
      submitLoading: false,
      customerMessage: {}
    }
  },
  methods: {

    formValue (val) {
      this.customerMessage = val
    },
    submitReview () {
      let data = {
        ids: [],
        newDiscountCoupons: null,
        oldDiscountCoupons: null
      }
      if (this.customerType === 'NEW') {
        data.newMoney = this.customerMessage.amount ? cashCount(this.customerMessage.amount) : null
        if (this.customerMessage.coupon_list && this.customerMessage.coupon_list.length > 0) {
          data.newDiscountCoupons = []
          this.customerMessage.coupon_list.forEach(item => {
            data.newDiscountCoupons.push({ id: item.id, amount: item.amount })
          })
        }
      } else if (this.customerType === 'OLD') {
        data.oldMoney = this.customerMessage.amount ? cashCount(this.customerMessage.amount) : null
        if (this.customerMessage.coupon_list && this.customerMessage.coupon_list.length > 0) {
          data.oldDiscountCoupons = []
          this.customerMessage.coupon_list.forEach(item => {
            data.oldDiscountCoupons.push({ id: item.id, amount: item.amount })
          })
        }
      }
      data.ids.push(this.id)
      this.submitReviewData(data)
    },

    submitReviewData (data) {
      this.form.validate().then(res => {
        this.submitLoading = true
        this.$store.dispatch('updateRewardAfterRejected', data).then(res => {
          this.submitLoading = false
          this.$message.success('提交成功')
          history.go(-1)
        }).catch(err => {
          this.submitLoading = false
          this.$message.error(err || '提交失败')
        })
      }).catch(err => {
        this.$message.error(err || '验证失败')
      })
    }
  }

}
</script>
<style module lang="less">

.customer-message-old-to-new{
  padding: 0 20px;
  :global
  .pt-message-table-item{
    :first-child{
 width: auto!important
    }

  }
  :global
  .pt-message-table-item{
    :first-child{
      width: 114PX
    }
  }
}

.reject-message{
  padding: 0 20px
}
</style>
